import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import JobService from '../../services/jobService'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      jobs: [],
      loading: false,
      showMessage: false,
      showMessage2: false,
      showMessage3: false,
      showMessage4: false
    }
  },
  components: {
    DashboardHeader,
    SideNav
  },
  mounted () {
    // window.analytics.page('allJobs')
    window.analytics.identify('allJobs', {
      path: '/allJobs'
    })
  },
  async created () {
    this.loading = true
    this.jobs = await JobService.listMiniJobs('ALL')
    this.loading = false
  },
  methods: {
    getDate (data) {
      const date = parseInt(data)
      const res = Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).format(new Date(date))
      return res
    }
  }
}
